module.exports = __webpack_public_path__ + "img/20210126_130637.787ec513.jpg";